module.exports = __webpack_public_path__ + "media/apps/mitch-ios-2-f24f3643.png";